// extend
export { CnTab, CnTabItem } from '@cainiaofe/cn-ui-m/es/components/cn-tab';
